var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileItemClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1ea149"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8411 11.6114L11.2904 7.15584C11.1848 7.05588 11.0436 7 10.8967 7C10.7499 7 10.6088 7.05588 10.5032 7.15584L10.1648 7.48713C10.0611 7.58968 10.0029 7.72818 10.0029 7.87252C10.0029 8.01685 10.0611 8.15535 10.1648 8.2579L13.9835 11.9968L10.1648 15.7424C10.1126 15.7927 10.0711 15.8527 10.0428 15.9189C10.0145 15.9851 10 16.0561 10 16.1278C10 16.1995 10.0145 16.2705 10.0428 16.3367C10.0711 16.4029 10.1126 16.4629 10.1648 16.5132L10.4963 16.8445C10.6015 16.9449 10.7429 17.0008 10.8898 17C11.0389 17.0011 11.1826 16.9453 11.2904 16.8445L15.8411 12.3889C15.9441 12.2834 16.0011 12.1427 15.9999 11.9968C16.0011 11.9254 15.9877 11.8545 15.9604 11.7883C15.9331 11.7222 15.8925 11.662 15.8411 11.6114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileItemClosed);
export default __webpack_public_path__ + "static/media/mobileItemClosed.f4322e8108e1edb9f8a6b8eee88f7398.svg";
export { ForwardRef as ReactComponent };